import { render, staticRenderFns } from "./OverseasEventPage.vue?vue&type=template&id=57c69eac&scoped=true"
import script from "./OverseasEventPage.vue?vue&type=script&lang=js"
export * from "./OverseasEventPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c69eac",
  null
  
)

export default component.exports